module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-07.d6f9b782.png";